import React from "react";
import img_1 from "../../assets/img/services-hmha.png";
import img_2 from "../../assets/img/services-sspba.png";
import img_3 from "../../assets/img/services-hsa.png";
import img_4 from "../../assets/img/services-bns.png";
import img_5 from "../../assets/img/services-ewd.png";
import img_6 from "../../assets/img/services-flee.png";
import img_7 from "../../assets/img/services-lscs.png";
import img_8 from "../../assets/img/services-coa.png";
import img_9 from "../../assets/img/services-api.png";
import { Link } from "react-router-dom";

const services = [
	{
		id: 1,
		title: "Healthcare & Mental Health Access",
		desc: "Quality healthcare and mental health support are critical for overall well-being, but many individuals encounter obstacles when trying to obtain these services. We facilitate access by linking people with reputable healthcare providers and mental health professionals to ensure timely, continuous care.",
		image: img_1,
		impactOfAbsence:
			"Without accessible care, delays in treatment can contribute to a 30% surge in emergency room visits and increased adverse health outcomes.",
		whatWeOffer: [
			{
				title: "Referral to Healthcare Providers",
				desc: "Connecting patients with primary care physicians, specialists, and hospitals",
			},
			{
				title: "Mental Health Support",
				desc: "Collaborating with licensed therapists and counselors for dedicated mental health care",
			},
			{
				title: "Substance Abuse & Rehabilitation Support",
				desc: "Referring individuals to trusted rehabilitation programs for addiction recovery",
			},
			{
				title: "Health Insurance Assistance",
				desc: "Offering guidance for enrollment in Medicaid, Medicare, and ACA programs",
			},
			{
				title: "Free/Low-Cost Health Screenings",
				desc: "Providing preventive tests such as blood pressure, diabetes, and HIV/AIDS screenings",
			},
			{
				title: "Telehealth & Virtual Care Assistance",
				desc: "Enabling access to remote consultations for prompt care",
			},
		],
		actionButton: "Get Started",
		actionUrl: "/get-started#form",
	},
	{
		id: 2,
		title: "Social Services & Public Benefits Access",
		desc: "Understanding and navigating public benefit programs can be overwhelming, leaving many without the assistance they require. We simplify the process by offering personalized support to help individuals secure essential benefits and social services that enhance financial stability and well-being.",
		image: img_2,
		impactOfAbsence:
			"In many communities, more than 50% of those eligible remain unenrolled in critical programs, resulting in heightened financial strain.",
		whatWeOffer: [
			{
				title: "Government Assistance Enrollment",
				desc: "Assisting with applications for SNAP, TANF, SSI, and SSDI",
			},
			{
				title: "Legal Aid Referral",
				desc: "Linking individuals with pro bono legal services for civil rights, housing, and benefit-related issues",
			},
			{
				title: "Support for Seniors & Disabled Individuals",
				desc: "Delivering specialized assistance for the elderly and persons with disabilities",
			},
			{
				title: "Child and Family Services Guidance",
				desc: "Offering direction for accessing family-oriented support programs",
			},
			{
				title: "Community Benefits Navigation",
				desc: "Providing expert advice to streamline public benefit applications",
			},
			{
				title: "Benefit Follow-up Support",
				desc: "Ensuring continued access and success with enrolled services",
			},
		],
		actionButton: "Get Started",
		actionUrl: "/get-started#form",
	},
	{
		id: 3,
		title: "Housing & Shelter Assistance",
		desc: "Access to stable housing is fundamental to achieving overall well-being, but many face insecurity or homelessness. Our partnerships with local housing initiatives enable us to connect individuals with safe, affordable, and sustainable housing solutions.",
		image: img_3, // Replace with the actual image import or path
		impactOfAbsence:
			"Housing instability is associated with a 25% higher incidence of chronic health problems and reduced employment opportunities.",
		whatWeOffer: [
			{
				title: "Temporary & Emergency Housing Referrals",
				desc: "Connecting individuals with shelters and transitional programs.",
			},
			{
				title: "Affordable Housing Resources",
				desc: "Assisting with the search for affordable housing options.",
			},
			{
				title: "Rental & Eviction Prevention Assistance",
				desc: "Providing guidance to secure rental support and avoid evictions.",
			},
			{
				title: "Transitional Housing for Ex-Offenders",
				desc: "Helping formerly incarcerated individuals reintegrate with stable housing.",
			},
			{
				title: "Utility Assistance Referral",
				desc: "Linking families with programs that aid with essential utility costs.",
			},
			{
				title: "Housing Counseling and Advocacy",
				desc: "Offering expert advice and advocacy to overcome housing challenges.",
			},
		],
		actionButton: "Explore Housing Resources",
		actionUrl: "/get-started#form",
	},
	{
		id: 4,
		title: "Basic Needs Support (Food, Clothing & Essentials)",
		desc: "Every individual deserves access to food, clothing, and basic supplies, yet many struggle to meet these fundamental needs. We work collaboratively with community partners to ensure that emergency and ongoing support is available to maintain health and dignity.",
		image: img_4, // Replace with the actual image import or path
		impactOfAbsence:
			"A shortage of basic necessities can drive up emergency service utilization by as much as 40%, further straining community resources.",
		whatWeOffer: [
			{
				title: "Food Pantry & Meal Programs",
				desc: "Distributing emergency food supplies and providing hot meals.",
			},
			{
				title: "Clothing & Hygiene Essentials",
				desc: "Supplying warm clothing and hygiene kits to those in need.",
			},
			{
				title: "Transportation Assistance",
				desc: "Offering vouchers and credits for essential travel.",
			},
			{
				title: "Emergency Shelter Information",
				desc: "Providing guidance to access temporary shelter options.",
			},
			{
				title: "Community Food Distribution",
				desc: "Organizing local food drives and distribution events.",
			},
			{
				title: "Essential Supplies Delivery",
				desc: "Coordinating the delivery of basic household items.",
			},
		],
		actionButton: "Visit Our Community Support Centers",
		actionUrl: "/get-started#form",
	},
	{
		id: 5,
		title: "Employment & Workforce Development",
		desc: "Achieving economic stability is critical for breaking cycles of poverty, yet many struggle to find or maintain meaningful employment. We deliver comprehensive career development services and job training programs designed to enhance employability and provide lasting economic opportunities.",
		image: img_5, // Replace with the actual image import or path
		impactOfAbsence:
			"Without robust employment support, unemployment rates can be up to 20% higher in underserved communities, deepening economic disparities.",
		whatWeOffer: [
			{
				title: "Job Placement & Career Counseling",
				desc: "Connecting individuals with job opportunities and professional mentorship.",
			},
			{
				title: "Resume Writing & Interview Preparation",
				desc: "Offering training to improve job readiness.",
			},
			{
				title: "Vocational & Technical Skills Training",
				desc: "Providing practical training in various industries and trades.",
			},
			{
				title: "Entrepreneurship & Business Start-Up Support",
				desc: "Supplying resources for individuals seeking to start their own business.",
			},
			{
				title: "Ex-Offender Employment Support",
				desc: "Facilitating skill-building and job placement for formerly incarcerated individuals.",
			},
			{
				title: "Career Mentorship Programs",
				desc: "Delivering ongoing professional guidance and support.",
			},
		],
		actionButton: "Start Your Career Journey",
		actionUrl: "/get-started#form",
	},
	{
		id: 6,
		title: "Financial Literacy & Economic Empowerment",
		desc: "Empowering individuals with financial knowledge is essential for achieving independence and economic security. We offer educational workshops and personalized support to build strong financial foundations and promote sustainable economic growth.",
		image: img_6, // Replace with the actual image import or path
		impactOfAbsence:
			"A lack of financial education can result in a 35% increase in financial instability and prevent individuals from breaking free of debt cycles.",
		whatWeOffer: [
			{
				title: "Budgeting & Financial Planning Workshops",
				desc: "Teaching effective money management and savings strategies.",
			},
			{
				title: "Credit Repair & Homeownership Education",
				desc: "Providing guidance on credit improvement and achieving homeownership.",
			},
			{
				title: "Small Business Support & Microloans",
				desc: "Assisting entrepreneurs with business planning and access to funding.",
			},
			{
				title: "Savings and Investment Guidance",
				desc: "Offering strategies to grow personal savings and investments.",
			},
			{
				title: "Financial Counseling and Debt Management",
				desc: "Delivering personalized support to reduce debt and enhance financial stability.",
			},
			{
				title: "Economic Empowerment Seminars",
				desc: "Hosting workshops to empower individuals with essential financial skills.",
			},
		],
		actionButton: "Empower Your Finances Now",
		actionUrl: "/get-started#form",
	},
	{
		id: 7,
		title: "Life Skills & Community Support",
		desc: "Developing essential life skills and fostering community connections is vital for personal and social well-being. Our programs empower individuals through mentorship, personal development, and supportive community networks. We help build resilience and enhance quality of life by offering practical guidance and connection opportunities.",
		image: img_7, // Replace with the actual image import or path
		impactOfAbsence:
			"Insufficient support and life skills training can increase the risk of social isolation and mental health challenges by up to 30% in vulnerable populations.",
		whatWeOffer: [
			{
				title: "Life Coaching & Mentorship",
				desc: "Delivering personalized coaching to support individual growth.",
			},
			{
				title: "Youth & Teen Empowerment Programs",
				desc: "Providing mentorship and after-school programs for at-risk youth.",
			},
			{
				title: "Family & Parenting Support",
				desc: "Conducting workshops on effective parenting and family dynamics.",
			},
			{
				title: "Domestic Violence & Abuse Support",
				desc: "Connecting survivors with shelters and legal assistance.",
			},
			{
				title: "Conflict Resolution Training",
				desc: "Offering programs to improve interpersonal skills and manage conflicts.",
			},
			{
				title: "Community Peer Support Groups",
				desc: "Facilitating group sessions that foster mutual support and shared experiences.",
			},
		],
		actionButton: "Strengthen Your Life Skills",
		actionUrl: "/get-started#form",
	},
	{
		id: 8,
		title: "Community Outreach & Advocacy",
		desc: "Active community engagement is essential for fostering change and ensuring that every voice is represented. Our outreach initiatives and advocacy training empower community members to participate in shaping policies and accessing available resources. We unite local organizations and individuals to create a stronger, more informed community.",
		image: img_8, // Replace with the actual image import or path
		impactOfAbsence:
			"Without effective outreach, community engagement can decline by over 50%, leaving many without awareness of available support services.",
		whatWeOffer: [
			{
				title: "Public Awareness Campaigns",
				desc: "Informing communities about essential resources and rights.",
			},
			{
				title: "Civic Engagement & Advocacy Training",
				desc: "Equipping individuals with the skills to influence policy and effect change.",
			},
			{
				title: "Neighborhood Support Programs",
				desc: "Collaborating with local organizations to provide coordinated community assistance.",
			},
			{
				title: "Community Partnership Development",
				desc: "Building networks to enhance collective support.",
			},
			{
				title: "Social Media Outreach Initiatives",
				desc: "Utilizing digital platforms to amplify our message.",
			},
			{
				title: "Volunteer Engagement Programs",
				desc: "Recruiting and mobilizing community volunteers for various initiatives.",
			},
		],
		actionButton: "Join Our Outreach Programs",
		actionUrl: "/get-started#form",
	},
	{
		id: 9,
		title: "Advocacy and Policy Influence",
		desc: "Transforming systems requires active participation in policy reform and advocacy efforts. We work to influence policy decisions and drive systemic change that improves healthcare access and promotes social equity. Our initiatives foster collaboration between community leaders, policymakers, and stakeholders to create lasting impact.",
		image: img_9, // Replace with the actual image import or path
		impactOfAbsence:
			"Ineffective advocacy can result in over 40% of underserved individuals being left without necessary reforms, perpetuating inequity in access to care.",
		whatWeOffer: [
			{
				title: "Engagement with Policymakers",
				desc: "Facilitating dialogue to reduce barriers to care.",
			},
			{
				title: "Promotion of Healthcare Initiatives",
				desc: "Advocating for enhanced affordability and accessibility.",
			},
			{
				title: "Collaboration with Stakeholders",
				desc: "Partnering with community leaders to drive policy reform.",
			},
			{
				title: "Public Campaigns",
				desc: "Raising awareness about critical issues and the need for change.",
			},
			{
				title: "Research-Backed Recommendations",
				desc: "Providing data-driven insights to guide policy development.",
			},
			{
				title: "Ongoing Policy Monitoring",
				desc: "Continuously evaluating and informing our advocacy strategies.",
			},
		],
		actionButton: "Support Our Advocacy",
		actionUrl: "/get-started#form",
	},
];

const ServicesList = () => {
	const isEven = (index) => {
		return index % 2 === 0;
	};
	return (
		<div className=''>
			{services.map((service, index) => (
				<div
					key={index}
					className={`w-full ${
						isEven(service.id) ? "bg-white" : " bg-[#F6FEFA]"
					}`}>
					<div
						className={`xl:w-full w-[90%] ${
							isEven(service.id) ? "max-w-[1028px]" : "max-w-[1197px]"
						} mx-auto py-10 space-y-8`}>
						<div className='space-y-[10px] max-w-[938px] w-full mx-auto text-center'>
							<h2 className='md:text-5xl/[68px] text-3xl/[40px] font-bold text-[#1D1D1D]'>
								{service.title}
							</h2>
							<p className='text-xl/8 font-normal text-[#667085]'>
								{service.desc}
							</p>
						</div>
						<div className='space-y-4 max-w-[734px] w-full mx-auto text-center'>
							<h4 className='md:text-4xl/[69px] text-3xl/[50px] font-bold text-[#1D1D1D]'>
								Impact of Absence
							</h4>
							<p className='text-xl/8 font-normal text-[#667085]'>
								{service.impactOfAbsence}
							</p>
						</div>

						<div
							className={`flex items-center justify-center lg:flex-nowrap flex-wrap pt-10 ${
								isEven(service.id)
									? "flex-col gap-10"
									: "flex-row md:gap-[60px] gap-10 lg:justify-between"
							} `}>
							<img
								src={service.image}
								alt='Description'
								className={`${
									isEven(service.id) ? "max-w-[777px] " : "max-w-[560px] xl:w-full lg:w-[50%]"
								} w-full h-auto`}
							/>
							<div className='space-y-5'>
								<h4
									className={`${
										isEven(service.id) ? "text-center" : "text-left"
									} text-[#034021] md:text-4xl/[69px] text-3xl/[50px] font-bold`}>
									What We Offer
								</h4>
								<ul className='w-full space-y-5 text-xl/8 font-medium list-outside list-disc lg:ml-7 ml-3'>
									{service.whatWeOffer.map((item, index) => (
										<li key={index} className='text-[#616E87]'>
											<span className='text-[#034021] font-semibold'>
												{item.title}:
											</span>{" "}
											{item.desc}
										</li>
									))}
								</ul>
								<Link
									to={service.actionUrl}
									className={`block md:text-lg/7 text-sm/5 w-fit lg:mx-0 mx-auto text-center rounded-[68px] py-3.5 md:px-[46px] px-10 bg-[#22E27F] border border-[#22E27F] hover:bg-transparent transition-all duration-600 font-semibold ${
										isEven(service.id) && "lg:mx-auto"
									}`}>
									{service.actionButton}
								</Link>
							</div>
						</div>
					</div>
				</div>
			))}
		</div>
	);
};

export default ServicesList;
